import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { SidebarConnect as ConnectSidebarType } from './ui/index.tsx';

const LazyConnectSidebar = lazyAfterPaint<typeof ConnectSidebarType>(() => {
	setPerformanceMarkLoadStart();
	return import(/* webpackChunkName: "async-sidebar-connect" */ './index').then((bundle) => {
		setPerformanceMarkLoadEnd();
		return bundle;
	});
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ConnectSidebar = memo<Record<any, any>>(() => (
	<SidebarBoundary id="connect">
		<LazyConnectSidebar />
	</SidebarBoundary>
));

ConnectSidebar.displayName = 'ConnectSidebar';

export default ConnectSidebar;
